import {Injectable} from '@angular/core';
import {TextBase} from '../classes/text-base';
import {RecordText} from './record-text';

/**
 * 입출력 시간 및 사용자 문자열
 *
 * @inheritDoc
 * @extends RecordText
 * @see TextBase
 * @deprecated LazyPhraseService 사용
 */
@Injectable({
	providedIn: 'root'
})
export class RecordByText extends TextBase {
	extendTexts = [RecordText];

	override readonly en = {
		insertedBy: 'Inserted By User',
		updatedBy: 'Updated By User',
		insertedAt$: 'Inserted at {{this}}'
	};

	override readonly kr = {
		insertedBy: '등록한 사용자',
		updatedBy: '수정한 사용자',
		insertedAt$: '{{this}} 등록'
	};
}
